import React from 'react';
import { Focusable, Icon, Text, View, createStyleSheet, useStyleSheet, useThemeContext } from '@gopeerproject/ui-kit';
export const Item = ({ item, onPress, selected }) => {
    const { size, color } = useThemeContext();
    const styles = useStyleSheet(getStyles);
    return (React.createElement(Focusable, { style: styles.item, hoverStyle: 'value' in item && styles.itemHover, focusable: 'value' in item, onPress: onPress },
        item.icon &&
            (typeof item.icon === 'string' ? (React.createElement(Icon, { name: item.icon, size: size.I, color: selected ? color.primary.solid : color.invert2.p100 })) : (React.createElement(View, { style: styles.externalIconContainer }, item.icon))),
        React.createElement(Text, { type: 'body', weight: 'regular', size: 'md', style: [styles.itemText, selected && styles.itemText__selected] }, item.label),
        React.createElement(View, { style: styles.checkmark }, selected && (React.createElement(Icon, { name: 'checkmark', size: size.I, color: (color) => color.primary.solid })))));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    item: {
        borderRadius: size.D,
        padding: size.E,
        gap: size.C,
        flexGrow: 1,
        flexShrink: 1,
        flexDirection: 'row',
        alignItems: 'center',
        cursor: 'default'
    },
    itemHover: { backgroundColor: color.invert2.p10, cursor: 'pointer' },
    itemText: {
        flexGrow: 1,
        overflow: 'hidden',
        ['white-space']: 'nowrap',
        ['text-overflow']: 'ellipsis'
    },
    itemText__selected: { color: color.primary.solid },
    externalIconContainer: { width: size.I, height: size.I },
    checkmark: { height: size.I, justifyContent: 'center' }
}));
//# sourceMappingURL=Item.js.map